import { Route, Switch } from 'react-router-dom';

import Detail from './Detail';
import List from './List';
import React from 'react';

function Careers() {
  return (
    <Switch>
      <Route exact path="/careers" component={List} />
      <Route path="/careers/:id" component={Detail} />
    </Switch>
  );
}

export default Careers;
